import styled from "styled-components";
import CompareTableRow from "./CompareTableRow";
const CompareTable = ({ contents }) => {
  return (
    <Div>
      {contents?.map((x, idx) => {
        return <CompareTableRow key={idx} contents={x} />;
      })}
    </Div>
  );
};
export default CompareTable;
const Div = styled.div`
  width: 100%;
  max-width: 62rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  border-top: 2px solid ${({ theme }) => theme.colors.dark};
`;
